export class SIQSuggestionTheme {
  textColor = "null";
  borderColor = "null";
  backgroundColor = "null";
  cornerRadius = null; // Int
  displayStyle = null; // Int
}
//# sourceMappingURL=SIQSuggestionTheme.js.map